// Role of an app user
export enum Role {
    NETWORK_ADMIN = "NETWORK_ADMIN",  // Mini City super-admin
    PARTNER_ADMIN = "PARTNER_ADMIN",  // Admin of a particular partner organization
    PARTNER_USER = "PARTNER_USER"    // Staff member of a particular partner organization
}

export enum Role_Label {
    NETWORK_ADMIN = "Network Admin",
    PARTNER_ADMIN = "Partner Admin",
    PARTNER_USER = "Partner User"
}

// App user header-level information
export interface Header {
    id: string;
    displayName: string;
    role?: Role;
}

export interface NotificationPreferences {
    subscribedEvents: string[];
}